var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 11,
    viewBox: "0 0 24 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 5c.613 0 1.14.368 1.373.895 4.076.653 7.253 4.172 7.596 8.534H24V16H0v-1.571l2.249-.001-1.863-1.952c.99-3.427 3.795-6.03 7.242-6.581C7.86 5.368 8.388 5 9 5z",
    transform: "translate(-1087 -33) translate(94 24) translate(993 4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store-icon.5907c13c3f6c68900a560178a2b39c37.svg";
export { ForwardRef as ReactComponent };